var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('calendar-mobile'):_c('calendar-desktop'),_c('ai-chat-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }